import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ObservabilityUploadController extends Controller {
  @tracked source = '';
  @tracked providers = '';
  @tracked returnTo = '';

  // NB: see https://guides.emberjs.com/v5.8.0/typescript/core-concepts/routing/#toc_controllers
  // for query param definition here
  queryParams = [
    {
      source: { type: 'string' as const },
      // NB: providers param intended as comma delimited list
      providers: { type: 'string' as const },
      // Route to navigate to after successful upload
      returnTo: { type: 'string' as const },
    },
  ];
}
